import React from 'react';
import * as styles from '../../DataExtractionTemplate.module.scss';
import { Popover, PopoverTrigger, PopoverContent } from 'components/core';
import { Text } from 'components/core';
import { useReviewFeaturesContext } from 'contexts/ReviewFeaturesProvider';

type Props = {
  weak?: boolean;
};

const OutcomePopoverText = ({ weak }: Props) => {
  const { hasSelectableMeasures } = useReviewFeaturesContext();

  const outcomesPopoverText1 = hasSelectableMeasures ? (
    <>continuous, dichotomous or qualitative</>
  ) : (
    <>continuous or dichotomous</>
  );

  const outcomesPopoverText2 = hasSelectableMeasures ? (
    <Text>
      If you think an outcome could be continuous, dichotomous or qualitative,
      then we suggest to add multiple outcomes with different types. This will
      make it easier to analyse and synthesise the data later.
    </Text>
  ) : (
    <Text>
      If you need both, we suggest to add two different outcomes as this will
      make it easier to analyse and synthesise the data later.
    </Text>
  );

  const themesPopoverText = hasSelectableMeasures ? (
    <Text>
      If you&apos;re looking to extract data such as themes or evaluations, you
      can add qualitative outcomes.
    </Text>
  ) : (
    <Text>
      If you&apos;re looking to extract data for a qualitative outcome like
      themes or evaluations, you can add an outcome which is either continuous
      dichotomous and use custom data types to extract qualitative data.
    </Text>
  );

  const variant = weak ? 'weak' : 'neutral';

  return (
    <Popover closeOnBlur={true} closeOnEscape={false} renderCloseButton={false}>
      <Text variant={variant}>
        Add the{' '}
        <PopoverTrigger>
          <Text component="span" className={styles.PopoverTrigger}>
            main outcomes
          </Text>
        </PopoverTrigger>
        <PopoverContent
          aria-label="Outcomes"
          className={styles.PopoverContentText}
        >
          <Text>
            Add the specific outcomes you are interested in investigating, which
            can be {outcomesPopoverText1}.
          </Text>
          {outcomesPopoverText2}
          {themesPopoverText}
        </PopoverContent>{' '}
        you plan to collect, based on your protocol. When extracting data from
        each study, you can select which outcomes are reported and add study
        specific sub-outcomes.
      </Text>
    </Popover>
  );
};

export default OutcomePopoverText;
